import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import dashboardReducer from "./slices/dashboardSlice";
import cincReducer, { categoryReducer } from "./slices/cincSlice";
import participantReducer from "./slices/participantSlice";
import galleryReducer from "./slices/gallerySlice";
import issuesReducer from "./slices/issuesSlice";

import usersReducer from "./slices/userSlice";
export const store = configureStore({
  reducer: {
    users: usersReducer,
    auth: authReducer,
    dashboard: dashboardReducer,
    cinc: cincReducer,
    categories: categoryReducer,
    participant: participantReducer,
    gallery: galleryReducer,
    issues: issuesReducer,
  },
});
